import React, { createContext, useContext, useMemo } from "react";
import { useEventHostAttention } from "./EventHostAttentionContext";

export const WaitlistUnreadContext = createContext(null);

const clampInt = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.floor(n));
};

export const formatUnreadBadge = (count) => {
  const n = clampInt(count);
  if (n <= 0) return "";
  if (n > 999) return "999+";
  return String(n);
};

const EMPTY_WAITLIST_UNREAD_CONTEXT = {
  totalUnread: 0,
  unreadEventsCount: 0,
  byEventId: {},
  eventMetaById: {},
  formatUnreadBadge,
  refetch: async () => {},
};

export const WaitlistUnreadProvider = ({ children }) => {
  const { data: attentionData, refetch } = useEventHostAttention();
  const data = attentionData?.waitlist;

  const value = useMemo(() => {
    const totalUnread = clampInt(data?.total_unread);
    const unreadEventsCount = clampInt(data?.unread_events_count);
    const byEventId = {};
    const eventMetaById = {};
    const eventsArr = Array.isArray(data?.events) ? data.events : [];

    eventsArr.forEach((item) => {
      const eventId = item?.event_id != null ? String(item.event_id) : null;
      if (!eventId) return;
      const unreadCount = clampInt(item?.unread_count);
      byEventId[eventId] = unreadCount;
      eventMetaById[eventId] = {
        eventId: Number(item?.event_id || 0) || null,
        eventName: String(item?.event_name || ""),
        unreadCount,
      };
    });

    return {
      totalUnread,
      unreadEventsCount,
      byEventId,
      eventMetaById,
      formatUnreadBadge,
      refetch,
    };
  }, [data, refetch]);

  return (
    <WaitlistUnreadContext.Provider value={value}>
      {children}
    </WaitlistUnreadContext.Provider>
  );
};

export const useWaitlistUnread = () => {
  const ctx = useContext(WaitlistUnreadContext);
  return ctx || EMPTY_WAITLIST_UNREAD_CONTEXT;
};
